<!-- <div class="row">
    <div class="col-md-12" style="background-color: #b6d7a8;">
        <h3 style="padding: 1rem;"> Follow Up Visit-Appointment</h3>
    </div>
</div> -->
<div>
    <h3 style="text-align: center;
    padding-top: 5em;">All Appointments Saved Sucessfully..!</h3>
</div>